<div class="app-container">
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
